const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = {
    avax: {
        id: 'avax',
        type: REFERENCE_ASSETS.AVAX,
        symbol: 'AVAX',
        decimals: 1e18,
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    },
    wavax: {
        id: 'wavax',
        type: REFERENCE_ASSETS.AVAX,
        symbol: 'WAVAX',
        decimals: 1e18,
        address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        coingeckoId: 'wrapped-avax',
    },
    daie: {
        id: 'daie',
        coingeckoId: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'DAI.e',
        decimals: 1e18,
        address: '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70',
    },
    adai: {
        id: 'adai',
        coingeckoId: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'aDAI.e',
        decimals: 1e18,
        address: '0x47AFa96Cdc9fAb46904A55a6ad4bf6660B53c38a',
        wrappedCoinType: 'aave',
    },
    adaiv3: {
        id: 'adaiv3',
        coingeckoId: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'aDAI.e',
        decimals: 1e18,
        address: '0x82E64f49Ed5EC1bC6e43DAD4FC8Af9bb3A2312EE',
        wrappedCoinType: 'aave',
    },
    usdce: {
        id: 'usdce',
        coingeckoId: 'usd-coin',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDC.e',
        decimals: 1e6,
        address: '0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664',
    },
    usdc: {
        id: 'usdc',
        coingeckoId: 'usd-coin',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDC',
        decimals: 1e6,
        address: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
    },
    ausdc: {
        id: 'ausdc',
        type: REFERENCE_ASSETS.USD,
        coingeckoId: 'usd-coin',
        symbol: 'aUSDC.e',
        decimals: 1e6,
        address: '0x46A51127C3ce23fb7AB1DE06226147F446e4a857',
        wrappedCoinType: 'aave',
    },
    ausdcv3: {
        id: 'ausdcv3',
        type: REFERENCE_ASSETS.USD,
        coingeckoId: 'usd-coin',
        symbol: 'aUSDC',
        decimals: 1e6,
        address: '0x625E7708f30cA75bfd92586e17077590C60eb4cD',
        wrappedCoinType: 'aave',
    },
    usdte: {
        id: 'usdte',
        coingeckoId: 'tether',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDT.e',
        decimals: 1e6,
        address: '0xc7198437980c041c805A1EDcbA50c1Ce5db95118',
    },
    usdt: {
        id: 'usdt',
        coingeckoId: 'tether',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDT',
        decimals: 1e6,
        address: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
    },
    ausdt: {
        id: 'ausdt',
        coingeckoId: 'tether',
        type: REFERENCE_ASSETS.USD,
        symbol: 'aUSDT.e',
        decimals: 1e6,
        address: '0x532E6537FEA298397212F09A61e03311686f548e',
        wrappedCoinType: 'aave',
    },
    ausdtv3: {
        id: 'ausdtv3',
        coingeckoId: 'tether',
        type: REFERENCE_ASSETS.USD,
        symbol: 'aUSDT',
        decimals: 1e6,
        address: '0x6ab707Aca953eDAeFBc4fD23bA73294241490620',
        wrappedCoinType: 'aave',
    },
    wbtc: {
        id: 'wbtc',
        coingeckoId: 'wrapped-bitcoin',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'wBTC.e',
        decimals: 1e8,
        address: '0x50b7545627a5162F82A992c33b87aDc75187B218',
    },
    aawbtc: {
        id: 'aawbtc',
        coingeckoId: 'wrapped-bitcoin',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'aaWBTC',
        decimals: 1e8,
        address: '0x686bEF2417b6Dc32C50a3cBfbCC3bb60E1e9a15D',
        wrappedCoinType: 'aave',
    },
    avWBTC: {
        id: 'avWBTC',
        coingeckoId: 'wrapped-bitcoin',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'avWBTC',
        decimals: 1e8,
        address: '0x686bEF2417b6Dc32C50a3cBfbCC3bb60E1e9a15D',
        wrappedCoinType: 'aave',
    },
    avWETH: {
        id: 'avWETH',
        coingeckoId: 'ethereum',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'avWETH',
        decimals: 1e18,
        address: '0x53f7c5869a859F0AeC3D334ee8B4Cf01E3492f21',
        wrappedCoinType: 'aave',
    },
    renbtc: {
        id: 'renbtc',
        coingeckoId: 'wrapped-bitcoin',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'renBTC.e',
        decimals: 1e8,
        address: '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
    },
    weth: {
        id: 'weth',
        coingeckoId: 'ethereum',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'WETH',
        decimals: 1e18,
        address: '0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB',
    },
};
